module.exports = __webpack_public_path__ + "static/media/clock-normal.efde15e0.svg";